import { AvailableDeliveryMethodsDetail } from "../../interfaces/session/ShoppingCart";
import { isPickUpDeliveryAvailable } from "./isPickUpDeliveryAvailable";

export function isDeliveryMethodUnAvailable(availableDeliveryMethods: AvailableDeliveryMethodsDetail[]) {
  const { pickUpAvailable, shipmentAvailable, deliveryAvailable } = isPickUpDeliveryAvailable(availableDeliveryMethods);
  return !pickUpAvailable && !shipmentAvailable && !deliveryAvailable;
}
